import Api from "@/services/Api";

export default {
  indexTypes() {
    return Api().get(`card_types`);
  },
  indexTypesByGame(gameId) {
    return Api().get(`card_types/by_game/${gameId}`);
  },
  indexFilteredTraits(form) {
    return Api().post(`card_traits`, form);
  },
  indexFilteredFronts(form) {
    return Api().post(`card_fronts`, form);
  }
};
